import { useEffect, useRef } from 'react';
import { useMessageStore } from '../stores/messageStore.js';
import { useChannelStore } from '../stores/channelStore.js';

export function useNotifications() {
  const permissionAsked = useRef(false);
  const lastMessageId   = useRef(null);

  const messages          = useMessageStore(s => s.messages);
  const currentChannelId  = useChannelStore(s => s.currentChannelId);

  // Request permission once on first interaction
  useEffect(() => {
    if (permissionAsked.current) return;
    if (!('Notification' in window)) return;
    if (Notification.permission === 'default') {
      // Ask on next user gesture rather than immediately
      const ask = () => {
        if (!permissionAsked.current) {
          permissionAsked.current = true;
          Notification.requestPermission();
        }
        document.removeEventListener('click', ask, { once: true });
      };
      document.addEventListener('click', ask, { once: true });
    } else {
      permissionAsked.current = true;
    }
  }, []);

  // Watch for new messages and fire notification when tab is hidden
  useEffect(() => {
    if (!messages.length) return;
    const latest = messages[messages.length - 1];
    if (!latest || latest.id === lastMessageId.current) return;
    lastMessageId.current = latest.id;

    // Only notify when tab is not visible and message is from another channel
    if (document.hidden && latest.channelId !== currentChannelId) {
      if (Notification.permission === 'granted') {
        const title = `#${latest.channelName || 'message'}`;
        const body  = `${latest.senderName || latest.author || 'Someone'}: ${(latest.text || latest.content || '').slice(0, 100)}`;
        const n = new Notification(title, { body, icon: '/favicon.ico', tag: latest.channelId });
        n.onclick = () => { window.focus(); n.close(); };
      }
    }
  }, [messages, currentChannelId]);
}
